import { takeEvery, put, call, fork, select } from "redux-saga/effects"
import { toast } from "react-toastify";
// Login Redux States
import { CREATE_EMAIL_SIGNATURE, GET_EMAIL_SIGNATURE, GET_SOCAIL_MEDIA, LOGIN_USER, LOGOUT_USER, POST_SOCAIL_MEDIA, UPDATE_EMAIL_SIGNATURE, UPDATE_SOCAIL_MEDIA, UPDATE_USER_CURRENCY, UPDATE_USER_TIMEZONE, USER_DETAIL, VERIFY_2FA, RESEND_2FA } from "./actionTypes"
import { loginSuccess, apiError, login2FARequired, getUserDetailSuccess, getUserDetailFail, createEmailSignatureSuccess, createEmailSignatureError, createSocailMediaSuccess, createSocailMediaError, getSocailMediaSuccess, getSocailMediaFail, updateSocailMediaError, getEmailSignatureSuccess, getEmailSignatureFail, updateEmailSignatureError, updateUserTimezoneFail  } from "./actions"
import { GET_LOCAL_DATA} from "../../localization/actionTypes"
import { getLocalDataSuccess} from "../../localization/actions"
import {
  postLogin,
  postVerify2FA,
  postResend2FA,
  getLocalDataApi,
  getUserDetailApi,
  updateUserCurrencyApi,
  postEMailSignatureApi,
  postEmailSignatureApi,
  postSocialmediaApi,
  getSocialmediaApi,
  updatetSocialmediaApi,
  getEmailSignatureApi,
  updatetEmailSignatureApi,
  updateUserTimezoneApi
} from "../../../helpers/backend_helper"

function* fetchAndStoreLocalData() {
  try {
    const resdata = yield call(getLocalDataApi);
    const newresdata = {};
    for (let i = 0, loc; i < resdata.length; i++) {
      loc = resdata[i];
      newresdata[loc.localizationResourceKey] = loc.localizationResourceValue;
    }
    localStorage.setItem("localData", JSON.stringify(newresdata));
    yield put(getLocalDataSuccess(resdata));
  } catch (error) {
    // Localization can load in background; login should not be blocked.
  }
}

function isTwoFactorChallenge(response) {
  const resultData = response?.resultData || {}
  return Boolean(
    resultData.requires2FA ||
    response?.messageKey === "TwoFactor_Required"
  )
}

function isTwoFactorResend(response) {
  return (
    response?.messageKey === "TwoFactor_ResendSuccess" ||
    Boolean(response?.resultData?.delivery)
  )
}

function clearAuthStorage() {
  localStorage.removeItem("token")
  localStorage.removeItem("refreshToken")
  localStorage.removeItem("userId")
  localStorage.removeItem("userName")
  localStorage.removeItem("userRole")
  localStorage.removeItem("brokerId")
  localStorage.removeItem("userModule")
  localStorage.removeItem("permissions")
  localStorage.removeItem("isChangePasswordRequired")
  sessionStorage.removeItem("authUser")
}

function* completeAuthenticatedLogin(response, history) {
  const dparse = response
  const resultData = dparse?.resultData || {}
  const userPortal = (resultData.userPortal ?? "").toString().trim()

  if (userPortal.toLowerCase() !== "realtor") {
    toast.dismiss()
    clearAuthStorage()
    yield put(apiError("Invalid User"))
    return
  }

  localStorage.setItem("token", resultData.bearerToken)
  localStorage.setItem("refreshToken", resultData.refreshToken)
  localStorage.setItem("userId", resultData.uId)
  localStorage.setItem("userName", resultData.userName)
  localStorage.setItem("userRole", resultData.userRole)
  localStorage.setItem("brokerId", resultData.createdBy)
  localStorage.setItem(
    "userModule",
    JSON.stringify(resultData.userRoleModulePermissionsList)
  )
  localStorage.setItem(
    "permissions",
    JSON.stringify(resultData.userRoleModulePermissions)
  )
  const mustChangePassword =
    resultData.isChangePasswordRequired === true ||
    String(resultData.isChangePasswordRequired).toLowerCase() === "true"

  if (mustChangePassword) {
    localStorage.setItem("isChangePasswordRequired", "true")
    sessionStorage.removeItem("authUser")
    yield put(loginSuccess(response))
    toast.dismiss()
    if (history.location?.pathname !== "/login") history.replace("/login")
    return
  }

  sessionStorage.setItem("authUser", JSON.stringify(dparse))
  localStorage.setItem("isChangePasswordRequired", "false")

  yield put(loginSuccess(response))
  toast.dismiss()
  history.push("/dashboard")
  yield fork(fetchAndStoreLocalData)
}

function* loginUser({ payload: { user, history } }) {
  try {
      toast.loading("Please wait...")
      localStorage.setItem("token", '');
      const response = yield call(postLogin, {
        userName: user.email,
        password: user.password,
        portal: "Realtor",
        turnstileToken: user.turnstileToken,
      })

      if (isTwoFactorChallenge(response)) {
        toast.dismiss()
        const resultData = response?.resultData || {}
        yield put(login2FARequired({
          challengeId: resultData.challengeId,
          provider: resultData.provider,
          mode: resultData.mode,
          delivery: resultData.delivery || {},
          resendAvailableInSeconds: resultData.resendAvailableInSeconds || 60,
          rememberDevice: Boolean(user.rememberMe),
        }))
        return
      }

      yield call(completeAuthenticatedLogin, response, history)
    }
catch (error) {
  toast.dismiss();
  const message =
    error?.response?.data?.messageDescription ||
    error?.response?.data?.message ||
    "Invalid User"
  yield put(apiError(message))
}
}

function* verifyTwoFactor({ payload: { code, rememberDevice, history } }) {
  try {
    toast.loading("Please wait...")
    const twoFactor = yield select((state) => state.Login.twoFactor)
    if (!twoFactor?.challengeId) {
      toast.dismiss()
      yield put(apiError("Verification session expired. Please sign in again."))
      return
    }

    const response = yield call(postVerify2FA, {
      challengeId: twoFactor.challengeId,
      code: String(code || "").trim(),
      rememberDevice: Boolean(
        rememberDevice !== undefined ? rememberDevice : twoFactor.rememberDevice
      ),
      useCookies: true,
    })

    if (response && response.success === false && !response?.resultData?.bearerToken) {
      toast.dismiss()
      yield put(apiError(
        response.messageDescription || response.message || "Invalid verification code"
      ))
      return
    }

    yield call(completeAuthenticatedLogin, response, history)
  } catch (error) {
    toast.dismiss()
    const message =
      error?.response?.data?.messageDescription ||
      error?.response?.data?.message ||
      "Invalid verification code"
    yield put(apiError(message))
  }
}

function* applyTwoFactorResponse(response, rememberDevice, existingTwoFactor = {}) {
  const resultData = response?.resultData || {}
  if (
    !isTwoFactorChallenge(response) &&
    !resultData.challengeId &&
    !isTwoFactorResend(response)
  ) {
    return false
  }
  yield put(login2FARequired({
    ...existingTwoFactor,
    challengeId: resultData.challengeId || existingTwoFactor.challengeId,
    provider: resultData.provider || existingTwoFactor.provider,
    mode: resultData.mode || existingTwoFactor.mode,
    delivery: {
      ...(existingTwoFactor.delivery || {}),
      ...(resultData.delivery || {}),
    },
    resendAvailableInSeconds: resultData.resendAvailableInSeconds || 60,
    rememberDevice: Boolean(rememberDevice),
    resendToken: Date.now(),
  }))
  return true
}

function* resendTwoFactor({ payload: { channel } }) {
  try {
    toast.loading("Please wait...")
    const twoFactor = yield select((state) => state.Login.twoFactor)
    if (!twoFactor?.challengeId) {
      toast.dismiss()
      yield put(apiError("Verification session expired. Please sign in again."))
      return
    }

    const response = yield call(postResend2FA, {
      challengeId: twoFactor.challengeId,
      channel: channel || "Sms",
    })
    toast.dismiss()

    if (response && response.success === false) {
      yield put(apiError(
        response.messageDescription || response.message || "Unable to resend the code"
      ))
      return
    }

    const applied = yield call(
      applyTwoFactorResponse,
      response,
      twoFactor.rememberDevice,
      twoFactor
    )
    if (!applied) {
      const resultData = response?.resultData || {}
      yield put(login2FARequired({
        ...twoFactor,
        delivery: {
          ...(twoFactor.delivery || {}),
          ...(resultData.delivery || {}),
        },
        resendAvailableInSeconds: resultData.resendAvailableInSeconds || 60,
        resendToken: Date.now(),
      }))
    }
    toast.success(response?.messageDescription || "Verification code resent.")
  } catch (error) {
    toast.dismiss()
    const message =
      error?.response?.data?.messageDescription ||
      error?.response?.data?.message ||
      "Unable to resend the code"
    yield put(apiError(message))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    //
    sessionStorage.removeItem("authUser");
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem('brokerId')
    localStorage.removeItem('userModule')
    localStorage.removeItem('userName')
    localStorage.removeItem('isChangePasswordRequired')
    //yield put(runLogoutTimer(0))
    history.push("/login")
  } catch (error) {
    yield put(apiError('some error'))
  }
}

function* fetchUserDetail({ agentId }) {
  try {
    const response = yield call(getUserDetailApi, agentId)
    yield put(getUserDetailSuccess(response))
  } catch (error) {
    yield put(getUserDetailFail(error))
  }
}

function* onUpdateUserCurrency({ payload: currency }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateUserCurrencyApi, currency)
    toast.dismiss();
    toast.success("Updated Successfully");
  } catch (error) {
    yield put(updateAppLocationTypeFail(error))
  }
}

function* submitEmailSignature({ payload:  signature  }) {
  try {
    
    toast.loading("Please wait...");

    const response = yield call(postEmailSignatureApi, signature);

    if (response.success) {
      yield put(createEmailSignatureSuccess(response));
      toast.dismiss();
      toast.success("Signature Created");
    } else {
      toast.dismiss();
      if (response.validationErrors && response.validationErrors.length > 0) {
        toast.warn(response.validationErrors[0]);
      } else {
        toast.warn("An error occurred while creating the signature.");
      }
    }
  } catch (error) {
    toast.dismiss();
    toast.error("Failed to create signature. Please try again.");
    yield put(createEmailSignatureError('Some Error'));
  }
}

function* submitSocialMedia({ payload:  socialmedia  }) {
  try {
    
    //toast.loading("Please wait...");

    const response = yield call(postSocialmediaApi, socialmedia);

    if (response.success) {
      yield put(createSocailMediaSuccess(response));
      //toast.dismiss();
      //toast.success("Social Media Submitted");
    } else {
      //toast.dismiss();
      if (response.validationErrors && response.validationErrors.length > 0) {
        //toast.warn(response.validationErrors[0]);
      } else {
        //toast.warn("An error occurred while creating the signature.");
      }
    }
  } catch (error) {
    toast.dismiss();
    toast.error("Failed to create Social Media. Please try again.");
    yield put(createSocailMediaError('Some Error'));
  }
}

function* fetchSocialMedia({ agentId }) {
  try {
    const response = yield call(getSocialmediaApi, agentId)
    yield put(getSocailMediaSuccess(response))
  } catch (error) {
    yield put(getSocailMediaFail(error))
  }
}

function* onUpdateSocialMedia({ payload: socialmedia }) {
  try {
    //toast.loading("Please wait...")
    const response = yield call(updatetSocialmediaApi, socialmedia)
    toast.dismiss();
    //toast.success("Socail Media Updated");
  } catch (error) {
    yield put(updateSocailMediaError(error))
  }
}

function* fetchEmailSignature({ agentId }) {
  try {
    const response = yield call(getEmailSignatureApi, agentId)
    yield put(getEmailSignatureSuccess(response))
  } catch (error) {
    yield put(getEmailSignatureFail(error))
  }
}
function* onUpdateEmailSignature({ payload: signature }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updatetEmailSignatureApi, signature)
    toast.dismiss();
    toast.success("Email Signature Updated");
  } catch (error) {
    yield put(updateEmailSignatureError(error))
  }
}



function* onUpdateUserTimezone({ payload: timezone }) {
  try {
    toast.loading("Please wait...")
    const response = yield call(updateUserTimezoneApi, timezone)
    toast.dismiss();
    toast.success("Updated Successfully");
  } catch (error) {
    yield put(updateUserTimezoneFail(error))
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(VERIFY_2FA, verifyTwoFactor)
  yield takeEvery(RESEND_2FA, resendTwoFactor)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeEvery(USER_DETAIL, fetchUserDetail)
  yield takeEvery(UPDATE_USER_CURRENCY, onUpdateUserCurrency)
  yield takeEvery(UPDATE_USER_TIMEZONE, onUpdateUserTimezone)
  yield takeEvery(CREATE_EMAIL_SIGNATURE, submitEmailSignature)
  yield takeEvery(POST_SOCAIL_MEDIA, submitSocialMedia)
  yield takeEvery(UPDATE_SOCAIL_MEDIA, onUpdateSocialMedia)
  yield takeEvery(GET_SOCAIL_MEDIA, fetchSocialMedia)
  yield takeEvery(GET_EMAIL_SIGNATURE, fetchEmailSignature)
  yield takeEvery(UPDATE_EMAIL_SIGNATURE, onUpdateEmailSignature)
}



export default authSaga
